export enum DialogFilesDetailProperties {
  DialogFilesPreviewWidth = '650px',
}
